// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type ButtonWheelCardsProps = {
  attempts: number;
  disabled: boolean;
  onClick: () => void;
};

const ButtonWheelCards = (props: ButtonWheelCardsProps) => {
  const { disabled, attempts, onClick } = props;
  const t = useTranslate();

  return (
    // eslint-disable-next-line react/button-has-type
    <button
      className="ButtonWheelCard"
      // eslint-disable-next-line react/jsx-handler-names
      onClick={onClick}
      disabled={disabled || attempts === 0}
    >
      <div className="ButtonWheelCard__text">{t("wheel.spin")}</div>
    </button>
  );
};

export default ButtonWheelCards;
